import { InjectionToken, NgModule, ModuleWithProviders } from '@angular/core';
import { EnrollComponent } from './enroll.component';
import { CaptureVideoComponent } from './capture-video/capture-video.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { EnrollService } from './enroll.service';

export interface LibConfig {
  apiUrl: string;
}

export const LibConfigService = new InjectionToken<LibConfig>('LibConfig');

@NgModule({
  declarations: [EnrollComponent, CaptureVideoComponent],
  imports: [CommonModule, HttpClientModule],
  exports: [EnrollComponent],
})
export class EnrollModule {
  static forRoot(
    config: LibConfig = {
      apiUrl:
        'https://dev-facade-1ton-http-635t26xtnq-uc.a.run.app/api/v1/one2n/enroll/',
    }
  ): ModuleWithProviders<EnrollModule> {
    return {
      ngModule: EnrollModule,
      providers: [
        EnrollService,
        {
          provide: LibConfigService,
          useValue: config,
        },
      ],
    };
  }
}
